
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, watch, onMounted, ref} from 'vue';
import {getRegionUrl} from "~vue/utils/urls.ts";
import {fetcher, assertData} from "~vue/utils/utils.ts";
import {RegionStruct} from "~vue/utils/structs.ts";
import RegionTeaser from "~vue/components/teasers/RegionTeaser.vue";
import {useTicketStore} from '~vue/stores/TicketStore.ts';
import {storeToRefs} from 'pinia'
import Error from "~vue/components/error/Error.vue";
import SectorMap from "~vue/components/sector-map/SectorMap.vue";

export default defineComponent({
    name: 'RegionView',
    components: {
        Error,
        RegionTeaser,
        SectorMap
    },
    emits: ['isLoading'],
    setup(props, {emit}) {

        const ticketStore = useTicketStore();
        const {
            selectedRegion,
            type
        } = storeToRefs(ticketStore);
        const {changeRegion, changeValidation, resetRegion} = ticketStore;

        const regions = ref<String[]>([]);
        const showError = ref<boolean>(false);
        const errorMessage = ref<String>('');
        const showMap = ref<boolean>(false);

        const fetchRegions = async () => {
            emit('isLoading', true);
            let url = getRegionUrl(type.value);
            await fetcher(url).then((result) => {
                if(result.success) {
                    assertData(result, RegionStruct, url, 'fetchRegions', 'danger');
                    regions.value = result.regions;
                    showError.value = false;
                    errorMessage.value = '';

                    //prefill selectedRegion
                    if(selectedRegion.value?.id === "") {
                        changeRegion('id', regions.value[0].id);
                        changeRegion('name', regions.value[0].name);
                        changeRegion('isMainRegion', regions.value[0].isMainRegion);
                    }
                } else {
                    showError.value = true;
                    errorMessage.value = result.errorMessage;
                }
                emit('isLoading', false);
            }).catch((error) => {
                console.warn(error);
                emit('isLoading', false);
                showError.value = true;
            });
        }

        watch(selectedRegion.value, (newValue, oldValue) => {
            if(newValue.id !== '') {
                changeValidation('region', true);
            }
            if(newValue.id !== oldValue.id) {
                resetRegion();
            }
        });

        const onChangeRegion = (region: Object) => {
            changeRegion('id', region.id);
            changeRegion('name', region.name);
            changeRegion('isMainRegion', region.isMainRegion);
        }

        onMounted(() => {
            fetchRegions();
        });

        return {
            translate,
            onChangeRegion,
            selectedRegion,
            showError,
            errorMessage,
            regions,
            showMap
        };
    }
});
